export function createPausenplanHealth({
  now = () => performance.now(), wallNow = () => Date.now(),
  reload = () => window.location.reload(), storage = null,
  schedule = setTimeout, cancel = clearTimeout
} = {}) {
  const events = [];
  let mounted = false;
  let visible = true;
  let fatal = false;
  let renderFailed = false;
  let lastUpdate = now();
  let timer = null;
  let localReload = null;
  let reported = null;
  function record(type, detail) {
    events.push({ at: wallNow(), type, detail: String(detail).slice(0, 300) });
    if (events.length > 30) events.shift();
  }
  function requestReload(reason) {
    let previous = localReload;
    try {
      const stored = Number(storage && storage.getItem("pausenplanWatchdogReload"));
      if (stored > 0) previous = Math.max(previous || 0, stored);
    } catch (error) { /* storage may be disabled */ }
    if (previous !== null && wallNow() - previous < 600000) {
      if (reported !== reason) record("reload-skipped", reason);
      reported = reason;
      return;
    }
    localReload = wallNow();
    try { if (storage) storage.setItem("pausenplanWatchdogReload", String(localReload)); } catch (error) { /* optional */ }
    record("reload", reason);
    reload();
  }
  function check() {
    if (!mounted || !visible) return;
    if (fatal) requestReload("fatal Vue patch/scheduler error");
    else if (now() - lastUpdate > 60000) requestReload("no successful Vue update for 60s");
  }
  return {
    events, record, check,
    start() { mounted = true; lastUpdate = now(); fatal = false; renderFailed = false; },
    updated() {
      // Vue also calls updated() after a failed render falls back to its old VNode.
      if (mounted && !renderFailed) lastUpdate = now();
      renderFailed = false;
    },
    visibility(value) { visible = value; lastUpdate = now(); },
    error(error, info) {
      record("vue-error", info + ": " + error.message);
      if (info === "render") renderFailed = true;
      if (mounted && info === "nextTick") {
        fatal = true;
        if (timer === null) timer = schedule(() => { timer = null; check(); }, 0);
      }
    },
    stop() { mounted = false; if (timer !== null) cancel(timer); timer = null; }
  };
}

// Plain, non-reactive state: updating diagnostics must not schedule another render.
export const pausenplanHealth = createPausenplanHealth({
  storage: typeof window === "undefined" ? null : {
    getItem: key => window.sessionStorage.getItem(key),
    setItem: (key, value) => window.sessionStorage.setItem(key, value)
  }
});
